import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

export default function SingleLevel({ item }) {
  return (
    <Link to={item.path} style={{ textDecoration: "none", color: "white" }}>
      <ListItem
        button
        style={{
          background:
            window.location.pathname === item.path ? "#36B057" : "none",
        }}
      >
        <ListItemIcon style={{ color: "white" }}>{item.icon}</ListItemIcon>
        <ListItemText primary={item.title} sx={{ marginLeft: "-5px" }} />
      </ListItem>
    </Link>
  );
}

SingleLevel.propTypes = {
  item: PropTypes.object,
};
